import areaCodeCN from '~/data/areaCodeCN.json'

type AreaCodeItem = {
  countryCode?: string
  twoCharCode?: string
}

type AreaCodeGroup = {
  data?: AreaCodeItem[]
}

const normalizeDisclosureText = (value: unknown) => String(value || '').trim()

export const normalizeDisclosureSlug = (value: unknown, fallback = 'regulator') => {
  const slug = normalizeDisclosureText(value)
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

  return slug || fallback
}

const areaCodeItems = (areaCodeCN as AreaCodeGroup[]).flatMap((group) =>
  Array.isArray(group.data) ? group.data : [],
)

const countryTwoCharCodeMap = new Map(
  areaCodeItems
    .map((item) => [normalizeDisclosureText(item.countryCode), normalizeDisclosureText(item.twoCharCode)] as const)
    .filter(([countryCode, twoCharCode]) => countryCode && twoCharCode),
)

export const resolveDisclosureCountryCode = (countryCode: unknown, fallbackCountryName?: unknown) => {
  const twoCharCode = countryTwoCharCodeMap.get(normalizeDisclosureText(countryCode))

  return normalizeDisclosureSlug(twoCharCode || fallbackCountryName, 'country')
}

export const buildDisclosureRegulatorSlug = (
  countryCode: unknown,
  regulatorName: unknown,
  fallbackCountryName?: unknown,
) => {
  const countrySlug = resolveDisclosureCountryCode(countryCode, fallbackCountryName)
  const regulatorSlug = normalizeDisclosureSlug(regulatorName)

  return `${countrySlug}-${regulatorSlug}`
}

export const buildDisclosureExchangeSlug = (englishFullName: unknown, fallbackExchangeSlug?: unknown) =>
  normalizeDisclosureSlug(englishFullName || fallbackExchangeSlug, 'exchange')
